var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticStyle:{"padding-left":"30px","padding-bottom":"10px"},attrs:{"type":"flex","justify":"space-between"}},[_c('el-row',{attrs:{"type":"flex"}},[_vm._t("default")],2),_c('el-row',{attrs:{"type":"flex"}},[_vm._t("right")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }